import { AppSchemasUserUserResponse, ProjectAdminSummary, DeviceAdminDetail, ProjectMedia, DeploymentAdminListDetail } from 'src/api/Api';

export interface AdminState {
  selectedProjectId?: string;
  selectedSiteId?: string;
  selectedLocationId?: string;
  selectedDeploymentId?: string;
  users: {
    data: AppSchemasUserUserResponse[];
    totalUsers: number;
    loading: boolean;
    error: string | null;
    page: number;
    rowsPerPage: number;
    orderBy: string;
    order: 'asc' | 'desc';
  };
  projects: ProjectAdminSummary[];
  devices: DeviceAdminDetail[];
  deployments: DeploymentAdminListDetail[];
  projectMedia: { [projectId: string]: ProjectMedia[] };
}

export const initialAdminState: AdminState = {
  selectedProjectId: undefined,
  selectedSiteId: undefined,
  selectedLocationId: undefined,
  selectedDeploymentId: undefined,
  users: {
    data: [],
    totalUsers: 0,
    loading: false,
    error: null,
    page: 0,
    rowsPerPage: 25,
    orderBy: 'created_at',
    order: 'desc',
  },
  projects: [],
  devices: [],
  deployments: [],
  projectMedia: {},
};
